import { render, staticRenderFns } from "./VariablesListModal.vue?vue&type=template&id=37b87cda"
import script from "./VariablesListModal.vue?vue&type=script&lang=js"
export * from "./VariablesListModal.vue?vue&type=script&lang=js"
import style0 from "./VariablesListModal.vue?vue&type=style&index=0&id=37b87cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports